import React, { useEffect, useState } from 'react';
import api from 'api';
import { Link } from 'react-router-dom';
import { API } from 'common/config-api';

/**
 * 메인 대시보드 페이지
 */
const Main = () => {
  const apiUrl = `${API.BASE_URL}`;

  const [todaySales, setTodaySales] = useState({
    totalAmount: 0,
    orderCount: 0,
    customerCount: 0,
  });
  const [recentSales, setRecentSales] = useState([]);
  const [topProducts, setTopProducts] = useState([]);

  // 오늘 날짜 포맷
  const today = new Date();
  const dateString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

  // 대시보드 데이터 조회
  const getDashboardData = async () => {
    try {
      // 오늘 판매 현황
      const salesRes = await api.get(`/sales/today`);
      if (salesRes.data) {
        setTodaySales(salesRes.data);
      }
    } catch (error) {
      console.error('대시보드 데이터 조회 실패:', error);
      alert('대시보드 데이터 조회 중 오류가 발생했습니다.');
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <div className="row">
      {/* 상단 요약 카드 */}
      <div className="col-lg-4">
        <div className="card info-card sales-card">
          <div className="card-body">
            <h5 className="card-title">오늘 판매액</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center"
                   style={{ backgroundColor: '#e0f7fa', width: '48px', height: '48px' }}>
                <i className="bi bi-currency-yen" style={{ color: '#00bcd4', fontSize: '24px' }}></i>
              </div>
              <div className="ps-3">
                <h6 style={{ fontSize: '28px', fontWeight: '700', color: '#012970' }}>
                  ￥{todaySales.totalAmount?.toLocaleString()}
                </h6>
                <span className="text-muted small">{dateString}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-4">
        <div className="card info-card revenue-card">
          <div className="card-body">
            <h5 className="card-title">오늘 주문 건수</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center"
                   style={{ backgroundColor: '#e8f5e9', width: '48px', height: '48px' }}>
                <i className="bi bi-cart-check" style={{ color: '#4caf50', fontSize: '24px' }}></i>
              </div>
              <div className="ps-3">
                <h6 style={{ fontSize: '28px', fontWeight: '700', color: '#012970' }}>
                  {todaySales.orderCount}건
                </h6>
                <span className="text-success small">
                  평균 ￥{todaySales.orderCount > 0
                    ? Math.round(todaySales.totalAmount / todaySales.orderCount).toLocaleString()
                    : 0}/건
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-4">
        <div className="card info-card customers-card">
          <div className="card-body">
            <h5 className="card-title">오늘 고객 수</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center"
                   style={{ backgroundColor: '#fff3e0', width: '48px', height: '48px' }}>
                <i className="bi bi-people" style={{ color: '#ff9800', fontSize: '24px' }}></i>
              </div>
              <div className="ps-3">
                <h6 style={{ fontSize: '28px', fontWeight: '700', color: '#012970' }}>
                  {todaySales.customerCount}명
                </h6>
                <span className="text-muted small">회원 + 비회원</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 최근 판매 내역 */}
      <div className="col-lg-6">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">
              최근 판매 내역
              <Link to="/sales/day" className="btn btn-sm btn-outline-primary float-end">
                전체보기
              </Link>
            </h5>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>시간</th>
                  <th>고객</th>
                  <th>상품수</th>
                  <th style={{ textAlign: 'right' }}>금액</th>
                </tr>
              </thead>
              <tbody>
                {recentSales.map((sale, index) => (
                  <tr key={index}>
                    <td>{sale.time}</td>
                    <td>{sale.customer}</td>
                    <td>{sale.products}개</td>
                    <td style={{ textAlign: 'right' }}>￥{sale.amount?.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* 인기 상품 */}
      <div className="col-lg-6">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">
              오늘 인기 상품
              <Link to="/statistics/manufacture/product" className="btn btn-sm btn-outline-primary float-end">
                전체보기
              </Link>
            </h5>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>상품명</th>
                  <th style={{ textAlign: 'right' }}>판매수</th>
                  <th style={{ textAlign: 'right' }}>금액</th>
                </tr>
              </thead>
              <tbody>
                {topProducts.map((product, index) => (
                  <tr key={index}>
                    <td>
                      <span className={`badge ${index < 3 ? 'bg-primary' : 'bg-secondary'}`}>
                        {index + 1}
                      </span>
                    </td>
                    <td>{product.name}</td>
                    <td style={{ textAlign: 'right' }}>{product.sales}개</td>
                    <td style={{ textAlign: 'right' }}>￥{product.amount?.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* 바로가기 */}
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">바로가기</h5>
            <div className="row">
              <div className="col-md-3 col-6 mb-3">
                <Link to="/pos" className="btn btn-lg btn-primary w-100 py-4">
                  <i className="bi bi-cart3 d-block" style={{ fontSize: '32px' }}></i>
                  POS
                </Link>
              </div>
              <div className="col-md-3 col-6 mb-3">
                <Link to="/product/list" className="btn btn-lg btn-success w-100 py-4">
                  <i className="bi bi-box-seam d-block" style={{ fontSize: '32px' }}></i>
                  상품관리
                </Link>
              </div>
              <div className="col-md-3 col-6 mb-3">
                <Link to="/user/list" className="btn btn-lg btn-info w-100 py-4 text-white">
                  <i className="bi bi-people d-block" style={{ fontSize: '32px' }}></i>
                  회원관리
                </Link>
              </div>
              <div className="col-md-3 col-6 mb-3">
                <Link to="/sales/day" className="btn btn-lg btn-warning w-100 py-4">
                  <i className="bi bi-graph-up d-block" style={{ fontSize: '32px' }}></i>
                  판매현황
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
